import { ApplicationState } from '..';

export const getCourseRecom = function getCourseRecom(state:ApplicationState) {
    //console.log(state);
    return state.courseRecom.allIds.map(function (id:string) {
      return state.courseRecom.byId[id];
    });
};

export const getCourseRecomByCategory = function getCourseRecomByCategory(state:ApplicationState) {
    //console.log(state);
     const results:any[] =[];
      if (state.userReducer.ProfessionalCategory){
        state.userReducer.ProfessionalCategory.map(
          (professionalCategoty:string) =>{
            let _category ="";
            if(professionalCategoty === "Accountant")
              _category = "Accountancy";
            else if( professionalCategoty ==="Engineers")
              _category = "Engineering";
            else if( professionalCategoty ==="Contractors")
              _category = "Contractors";
      
            if( _category !=="" &&  state.courseRecom.byCategory[_category] !== undefined)
            {
              results.push({Category:_category, Courses:state.courseRecom.byCategory[_category].map(function (id:string) {
                  return state.courseRecom.byId[id];
                }) 
              });
            }
          }
        );
      }

      return results;
};


  export const getSelectedCourse = (state: ApplicationState) => state.courseRecom.byId[state.courseRecom.ui.selected];
